import { maskValue } from 'utils/maskValue';

export const unformatValue = (value: string | undefined) => {
  if (!value) return '';

  return value.replace('+7', '').replace(/\D/g, '').slice(0, 10);
};

export const getIsComplete = (value: string) => {
  return unformatValue(value).length >= 10;
};

const COUNTRY_CODE_DIGITS = [7, 8];

export const getIsPhoneNumber = (value: string) => {
  const _value = value.replace(/\D/g, '');
  return [6, 9, ...COUNTRY_CODE_DIGITS] //
    .map(String)
    .includes(_value[0]);
};

export const formatValue = (
  value: string | undefined,
  phoneMask: string = '+7 ___ ___ ____',
  nonPhoneMask: string = '___ ___ ____',
) => {
  if (!value) return '';
  const _value = value.replace(/\D/g, '');
  const isPhoneNumber = getIsPhoneNumber(_value);
  if (!isPhoneNumber) return maskValue(_value, nonPhoneMask);
  const _phone = _value.replace(new RegExp(`^[${COUNTRY_CODE_DIGITS.toString()}]`), '');
  return maskValue(_phone, phoneMask);
};
